import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_MAP } from 'src/constants';
import { getSimCardDetailsPagePromise } from 'src/utils/api/get-sim-card-details';

interface UseGetSimCardDetailsParams {
  page: number;
  status?: string;
}

export const useGetSimCardDetails = ({ page, status = undefined }: UseGetSimCardDetailsParams) => {
  const { data, isLoading, isFetching, error, isRefetching } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetSimCardDetails, page, status],
    queryFn: () => getSimCardDetailsPagePromise({ page, status }),
  });

  return {
    data,
    isLoading,
    error,
    isRefetching,
    isFetching,
  };
};
